import React from 'react';
import './NutritionFacts.css';

const NutritionFacts = ({ nutrition, dailyValues, servings = 1, servingUnit = '份' }) => {
  return (
    <div className="nutrition-facts">
      <div className="nutrition-header">
        <h3>营养成分表</h3>
        <p className="serving-size">每份 ({servings} {servingUnit})</p>
      </div>
      
      <div className="nutrition-content">
        <div className="nutrition-row main">
          <span className="nutrient">热量</span>
          <span className="value">{nutrition.calories} kcal</span>
        </div>
        
        <div className="nutrition-divider"></div>
        
        <div className="nutrition-row">
          <span className="nutrient">总脂肪</span>
          <span className="value">{nutrition.totalFat}g</span>
          <span className="daily-value">{dailyValues.totalFat}%</span>
        </div>
        
        <div className="nutrition-row sub">
          <span className="nutrient">饱和脂肪</span>
          <span className="value">{nutrition.saturatedFat}g</span>
        </div>
        
        <div className="nutrition-row sub">
          <span className="nutrient">反式脂肪</span>
          <span className="value">{nutrition.transFat}g</span>
        </div>
        
        <div className="nutrition-row">
          <span className="nutrient">胆固醇</span>
          <span className="value">{nutrition.cholesterol}mg</span>
          <span className="daily-value">{dailyValues.cholesterol}%</span>
        </div>
        
        <div className="nutrition-row">
          <span className="nutrient">钠</span>
          <span className="value">{nutrition.sodium}mg</span>
          <span className="daily-value">{dailyValues.sodium}%</span>
        </div>
        
        <div className="nutrition-row">
          <span className="nutrient">总碳水化合物</span>
          <span className="value">{nutrition.totalCarbohydrates}g</span>
          <span className="daily-value">{dailyValues.totalCarbohydrates}%</span>
        </div>
        
        <div className="nutrition-row sub">
          <span className="nutrient">膳食纤维</span>
          <span className="value">{nutrition.dietaryFiber}g</span>
          <span className="daily-value">{dailyValues.dietaryFiber}%</span>
        </div>
        
        <div className="nutrition-row sub sugar-highlight">
          <span className="nutrient">糖</span>
          <span className="value">{nutrition.sugar}g</span>
        </div>
        
        <div className="nutrition-row sub">
          <span className="nutrient">净碳水化合物</span>
          <span className="value">{nutrition.netCarbs}g</span>
        </div>
        
        <div className="nutrition-row">
          <span className="nutrient">蛋白质</span>
          <span className="value">{nutrition.protein}g</span>
          <span className="daily-value">{dailyValues.protein}%</span>
        </div>
      </div>
      
      <div className="nutrition-footer">
        <p>* 每日参考值基于2000卡路里饮食</p>
      </div>
    </div>
  );
};

export default NutritionFacts;
